export const environment = {
  envName: 'DEV',
  apiUrl:
    'https://nanaykuna-progresolplus-dev-backoffice-api-app-001.azurewebsites.net/',
  backOfficeUrl: 'https://backoffice2-dev.progresolplus.pe/',
  gaMeasurementId: '',
};
